import { Grid } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import type { TipoGanado } from '../../stores/tipos-ganado/tipo-ganado';
import type {
  ActualizarTipoGanado,
  RegistrarTipoGanado
} from '../../stores/tipos-ganado/tipos-ganado.store';
import { useUIStore } from '../../stores/ui/ui.store';
import type { CommonEntityFormProps } from '../../utils/common-entity-form-props';
import { getLengthOrErrorText } from '../../utils/get-length-or-error-text';
import AppTextField from '../ui/AppTextField';
import EditForm from '../ui/EditForm';

const validationSchema = yup.object({
  id: yup.number(),
  descripcion: yup.string().required('La descripción es requerida')
});

type TipoGanadoFormProps = {
  tipo?: TipoGanado;
  onSave:
    | ((values: ActualizarTipoGanado) => Promise<void>)
    | ((values: RegistrarTipoGanado) => Promise<boolean>);
} & CommonEntityFormProps;

const TipoGanadoForm = ({ tipo, esAgregar, onSave, onDelete, onActivate }: TipoGanadoFormProps) => {
  const esEditar = !esAgregar;
  const activo = esAgregar || tipo?.activo === true;
  const inactivo = !activo;
  const status = activo ? 'ACTIVO' : 'INACTIVO';
  const { loading } = useUIStore((state) => state);
  const initialValues = {
    id: tipo?.id ?? '',
    descripcion: tipo?.descripcion ?? ''
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const success = await onSave(values);
      if (success) {
        formik.resetForm();
      }
    },
    enableReinitialize: true
  });

  const reset = () => formik.resetForm({ values: initialValues });

  return (
    <EditForm
      module="tipos-ganado"
      title="Tipos de Ganado"
      readonly={!activo}
      returnLink="/tipos-ganado"
      loading={loading}
      showActivate={false}
      showDelete={esEditar}
      onSave={formik.handleSubmit}
      onClear={reset}
      onDelete={onDelete}
      onActivate={onActivate}
    >
      <Grid>
        <Grid container spacing={2}>
          <Grid>
            <AppTextField
              name="id"
              label="Código"
              placeholder="Código"
              value={formik.values.id}
              disabled={true}
            />
          </Grid>
          <Grid size="grow">
            <AppTextField
              name="descripcion"
              label="Descripción"
              placeholder="Descripción"
              maxLength={40}
              disabled={loading || inactivo}
              value={formik.values.descripcion}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.descripcion && Boolean(formik.errors.descripcion)}
              helperText={getLengthOrErrorText(
                formik.touched.descripcion ? formik.errors.descripcion : '',
                formik.values.descripcion.length,
                40
              )}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Grid container>
          <AppTextField label="Status" value={status} disabled={true} />
        </Grid>
      </Grid>
    </EditForm>
  );
};

export default TipoGanadoForm;
